/**
 * This is a no-operation dummy class that exists only to allow LTS seed builds not to fail.
 * The seed project used to reference FSBL.Clients.SmartDesktopClient. This is no longer the
 * case since the SDD has been moved into packages/platform, but existing clients still have
 * a components/SmartDesktopClient/SmartDesktopClient.tsx file in their seed that requires
 * this code in order to operate.
 */

/**
 * Deprecated, do not use
 */
export class SmartDesktopClient {
	resetProject() {}

	getSDServerInfo() {}

	getProjectSettings() {}

	updateProjectSettings(settings: any) {}

	static onThemeUpdated(callback: any) {}

	selectProjectPath() {}
}
